export default __webpack_public_path__ + "static/media/circle-check.30d656d2.svg";